export default function quickLinks() {
	const quickLinks = document.querySelectorAll('.c-quick-links');

	quickLinks.forEach(quickLink => {
		const icon = quickLink.querySelector('.c-quick-links__icon');
		const title = quickLink.querySelector('.c-quick-links__title');

		icon.addEventListener('click', () => {
			quickLink.classList.toggle('active');
		});

		title.addEventListener('click', () => {
			quickLink.classList.toggle('active');
		});
	});

	// if more than 1024px add class show on quick links 2s after page load
	if (window.innerWidth > 1024) {
		setTimeout(() => {
			quickLinks.forEach(quickLink => {
				quickLink.classList.add('show');
			});
		}, 3000);
	}
}